import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Flex, HStack, Image, Stack, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useCallback, useMemo } from 'react';
import { MenuItemType } from 'src/types';
import { APP_RELEASE_VERSION, APP_VERSION, get_MENU_DATA } from '../../constants';
import AuthLinking from '../AuthLinking';
import Header from '../Header';
import { Nav } from './Nav';
import { NavGroup } from './NavGroup';
import { NavItem } from './NavItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ShellWithGroupedMenu = function ShellWithGroupedMenu(_ref) {
  var showSideBar = _ref.showSideBar,
      setShowSideBar = _ref.setShowSideBar,
      sideBarWidth = _ref.sideBarWidth;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var toggleShowSideBar = useCallback(function () {
    setShowSideBar(!showSideBar);
  }, [setShowSideBar, showSideBar]);
  var MENU_DATA = useMemo(function () {
    var _get_MENU_DATA;

    return (_get_MENU_DATA = get_MENU_DATA()) === null || _get_MENU_DATA === void 0 ? void 0 : _get_MENU_DATA.filter(function (item) {
      return !item.hide;
    });
  }, []);
  return /*#__PURE__*/_jsx(Box, {
    overflowY: "auto",
    e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Box",
    children: /*#__PURE__*/_jsx(Flex, {
      whiteSpace: "nowrap",
      id: "app-container",
      e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Flex",
      children: /*#__PURE__*/_jsx(Box, {
        w: sideBarWidth,
        color: "#ffffff",
        fontSize: "sm",
        e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Box",
        children: /*#__PURE__*/_jsxs(Flex, {
          h: "100vh",
          direction: "column",
          px: "4",
          py: "4",
          e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Flex",
          children: [/*#__PURE__*/_jsx(Stack, {
            e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Stack",
            children: /*#__PURE__*/_jsx(Header, {
              showText: showSideBar,
              e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Header"
            })
          }), /*#__PURE__*/_jsx(Stack, {
            spacing: showSideBar ? 3 : 1,
            flex: "1",
            overflow: "auto",
            e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Stack",
            children: MENU_DATA.map(function (item) {
              var _item$subMenus, _item$subMenus$filter;

              return /*#__PURE__*/_jsx(AuthLinking, _objectSpread(_objectSpread({}, item), {}, {
                e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_AuthLinking",
                children: /*#__PURE__*/_jsx(NavGroup, {
                  showSideBar: showSideBar,
                  label: t("common:menu.".concat(item === null || item === void 0 ? void 0 : item.id)),
                  e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_NavGroup",
                  children: item === null || item === void 0 ? void 0 : (_item$subMenus = item.subMenus) === null || _item$subMenus === void 0 ? void 0 : (_item$subMenus$filter = _item$subMenus.filter(function (item) {
                    return !item.hide;
                  })) === null || _item$subMenus$filter === void 0 ? void 0 : _item$subMenus$filter.map(function (res) {
                    var _res$subMenus;

                    var isOpenNewWindow = res.isOpenNewWindow || res.type === MenuItemType.externalLink;
                    var isSubMenu = (res === null || res === void 0 ? void 0 : (_res$subMenus = res.subMenus) === null || _res$subMenus === void 0 ? void 0 : _res$subMenus.length) > 0;
                    return /*#__PURE__*/_jsx(AuthLinking, _objectSpread(_objectSpread({
                      target: isOpenNewWindow ? '_blank' : '_self'
                    }, res), {}, {
                      e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_AuthLinking",
                      children: isSubMenu ? /*#__PURE__*/_jsx(Nav, {
                        data: res,
                        activeColor: item.activeColor,
                        showSideBar: showSideBar,
                        e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Nav"
                      }) : /*#__PURE__*/_jsx(NavItem, {
                        activeColor: item.activeColor,
                        config: res,
                        showSideBar: showSideBar,
                        label: t(res === null || res === void 0 ? void 0 : res.i18n, res.title),
                        e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_NavItem"
                      })
                    }), res.id);
                  })
                }, item.title)
              }), item.id);
            })
          }), /*#__PURE__*/_jsx(Box, {
            e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Box",
            children: /*#__PURE__*/_jsxs(HStack, {
              w: "full",
              justifyContent: "flex-end",
              e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_HStack",
              children: [showSideBar && /*#__PURE__*/_jsxs(VStack, {
                spacing: "0",
                e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_VStack",
                children: [/*#__PURE__*/_jsxs(Text, {
                  e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Text",
                  children: ["v.", APP_RELEASE_VERSION]
                }), /*#__PURE__*/_jsxs(Text, {
                  fontSize: "xs",
                  color: "gray.300",
                  e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Text_16",
                  children: ["FE:", APP_VERSION]
                })]
              }), /*#__PURE__*/_jsx(Box, {
                w: 10,
                e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Box",
                children: /*#__PURE__*/_jsx(Image, {
                  boxSize: 6,
                  onClick: toggleShowSideBar,
                  alt: "icon",
                  cursor: "pointer",
                  src: "/shrink-".concat(showSideBar ? 'active' : 'unactive', ".svg"),
                  e2eid: "ShellWithGroupedMenu_ShellWithGroupedMenu_Image"
                })
              })]
            })
          })]
        })
      })
    })
  });
};

export default ShellWithGroupedMenu;